// ESM-Huelle fuer lib/scripts/components/CMP_CCaption.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CCaption(id)
{
    this.construct(id);

    this.name = "CCaption";    
    this.htmlType = "p";
    
    this.properties =
    {
        value: "caption",
        styles:
        {
        }
    }
}

CCaption.prototype = new CComponent;
export { CCaption };
